import React from 'react';
import { Menu } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import { navigation } from '../../shared/URL';
import './motivation.scss';

type Props = {
  title: string;
  activeTab: 'categories' | 'first-sale' | 'missions';
  children: React.ReactNode;
};

const MotivationLayout = ({ title, activeTab, children }: Props) => (
  <div className="page table-page motivation-page">
    <h1 className="page__header">{title}</h1>

    <Menu pointing secondary className="motivation-page__tabs">
      <Menu.Item
        as={Link}
        to={navigation.motivationCategories}
        active={activeTab === 'categories'}
      >
        Категории
      </Menu.Item>
      <Menu.Item
        as={Link}
        to={navigation.motivationMissions}
        active={activeTab === 'missions'}
      >
        Миссии
      </Menu.Item>
      <Menu.Item
        as={Link}
        to={navigation.motivationFirstSale}
        active={activeTab === 'first-sale'}
      >
        Первая продажа месяца
      </Menu.Item>
    </Menu>

    {children}
  </div>
);

export default MotivationLayout;
